<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <v-file-input
          accept="text/csv"
          @change="readSingleFile"
          label="CSVファイルの読み込み"
          outlined
          dense
        ></v-file-input>
      </v-col>
      <v-overlay :absolute="false" :opacity="opacity" :value="loadingStatus" :z-index="zIndex">
        <v-progress-circular
          indeterminate
          :size="120"
          :width="15"
          :value="loadingMessage"
          color="teal"
        >{{ loadingMessage }}</v-progress-circular>
      </v-overlay>
    </v-row>
    <v-row>
      <v-col cols="8">
        <v-select
          v-model="selectedFile"
          :items="sampleList"
          item-text="text"
          item-value="value"
          label="サンプルCSVファイル"
        ></v-select>
      </v-col>
      <v-col cols="4">
        <v-btn :disabled="selectedFile == null" @click="readSampleCsvFile()">読み込み</v-btn>
        <v-btn :disabled="selectedFile == null" @click="downloadCsvFile()">ダウンロード</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="points" :items-per-page="5" class="elevation-1"></v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as turf from "../plugins/turf";
import axios from "axios";

import {
  SET_CENTER_POINT,
  PUSH_POINT,
  REMOVE_ALL_POINTS,
  SET_FEATURE_COLLECTION,
  SET_MEASURES
} from "../mutation-types";

export default {
  computed: {
    points() {
      return this.$store.getters.points;
    },
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
    selectedFileName() {
      let name = /(?:[^/][\d\w.]+)$/.exec(this.selectedFile);
      if (name == null) return "sample.csv";
      return name[0];
    },
    sampleList() {
      return this.$store.getters.sampleList;
    }
  },
  data() {
    return {
      centerPoint: null,
      featureCollection: null,
      headers: [
        { text: "名前", value: "name" },
        { text: "緯度", value: "lat" },
        { text: "経度", value: "long" }
      ],
      stations: [],
      absolute: false,
      opacity: 0.2,
      zIndex: 5,
      loadingMessage: "ロード中",
      selectedFile: null
    };
  },
  mounted() {
    if (this.$store.getters.sampleList.length == 0) {
      this.$store.dispatch("fetchSampleList");
    }
  },
  methods: {
    readSampleCsvFile() {
      axios({
        url: this.selectedFile,
        method: "GET",
        responseType: "blob" // important
      }).then(response => {
        let blob = new Blob([response.data]);
        this.readSingleFile(blob);
      });
    },
    downloadCsvFile() {
      axios({
        url: this.selectedFile,
        method: "GET",
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", this.selectedFileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    readCSVFile(file) {
      /* シンプルだがSafariでは動かず  */
      if (!(file instanceof Blob)) return;
      file.text().then(text => {
        this.parseContent(text);
      });
    },
    async getFileContent(file) {
      /* プロミス */
      if (!(file instanceof Blob)) return;
      try {
        const content = await this.readFileAsync(file);
        this.parseContent(content);
      } catch (e) {
        window.console.log(e);
      }
    },
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    readMultiFiles: function(files) {
      /* 複数ファイル選択 */
      if (!(files[0] instanceof Blob)) return;
      const reader = new FileReader();
      const loadFunc = () => {
        const lines = reader.result;
        this.parseContent(lines);
      };
      reader.onload = loadFunc;
      reader.readAsText(files[0]);
    },
    readSingleFile: function(file) {
      /* 単独ファイル選択 */
      if (!(file instanceof Blob)) return;
      const reader = new FileReader();
      const loadFunc = () => {
        const lines = reader.result;
        this.$store.commit(SET_MEASURES, []);
        this.$store.commit(REMOVE_ALL_POINTS);
        this.parseContent(lines);
      };
      reader.onload = loadFunc;
      reader.readAsText(file);
    },
    getIndex(headers, indexEnum) {
      let index = headers.indexOf(this.headers[indexEnum].value);
      if (index == -1) {
        index = indexEnum;
      }
      return index;
    },
    parseContent(content) {
      let lines = content
        .split(/\r\n|\r|\n/)
        .map(line => line.trim().split(/,/));
      let headers = lines.splice(0, 1)[0];
      const IndexEnum = { NAME: 0, LATITUDE: 1, LONGITUDE: 2 };
      let nameIndex = this.getIndex(headers, IndexEnum.NAME);
      let latIndex = this.getIndex(headers, IndexEnum.LATITUDE);
      let longIndex = this.getIndex(headers, IndexEnum.LONGITUDE);
      let points = [];
      let rowPoints = [];
      lines.forEach((line, index) => {
        if (typeof line.length === "undefined") {
          return;
        }
        const long = parseFloat(line[longIndex]);
        const lat = parseFloat(line[latIndex]);
        if (isNaN(long) || isNaN(lat)) return;
        const point = {
          id: index + 1,
          name: line[nameIndex],
          lat: lat,
          long: long
        };
        points.push(turf.point([long, lat]));
        rowPoints.push([lat, long]);
        this.$store.commit(PUSH_POINT, point);
      });
      let features = turf.featureCollection(points);
      this.centerPoint = turf.center(features);
      let collection = turf.lineString(rowPoints);
      this.featureCollection = collection;
      this.$store.commit(SET_FEATURE_COLLECTION, collection);
      this.$store.commit(SET_CENTER_POINT, {
        longitude: this.centerPoint.geometry.coordinates[0],
        latitude: this.centerPoint.geometry.coordinates[1]
      });
      this.$store.dispatch("fetchMeshdata");
    }
  }
};
</script>
